<div
  class="mt-4 flex flex-col flex-wrap justify-between gap-6 @xl/main-panel-container:flex-row @xl/main-panel-container:flex-nowrap"
>
  <div
    class="flex flex-col-reverse gap-3 @xl/main-panel-container:flex-row @xl/main-panel-container:gap-0"
  >
    <div class="left-section flex shrink-0 gap-3">
      <slot name="left-section" />
    </div>

    <div class="flex before:bg-black/10 dark:before:bg-white/10">
      <slot name="middle-section" />
    </div>
  </div>
  <div class="ml-auto hidden shrink-0 items-center self-end pl-4 @xl/main-panel-container:flex">
    <slot name="right-section" />
  </div>
</div>

<style lang="postcss">
  @container main-panel-container (min-width: 576px) {
    .left-section:not(:empty) + div:not(:empty):before {
      @apply mx-3 inline-flex h-[20px] w-[1px] rounded-3xl content-[''];
    }
  }
</style>
